import { useOktaAuth } from '@okta/okta-react'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import actionsService from '../services/actionsService'
import { LOGIN_REDIRECT_PATH } from '../authentication/oktaConfig'

/**
 * Custom hook that tracks the page load events
 */
export function useRouteTracker() {
  const { authState } = useOktaAuth()
  const location = useLocation()

  useEffect(() => {
    if (authState?.isAuthenticated) {
      // Exclude the search parameters for the login redirect path, so as not to store
      // any potentially sensitive information
      const fullPagePath = location.pathname === LOGIN_REDIRECT_PATH ? location.pathname : location.pathname + location.search
      actionsService.userAnalytics.postEvent('PageLoad', '', fullPagePath, window.location.hostname)
    }
  }, [authState?.isAuthenticated, location.pathname, location.search, window.location.hostname])
}

export default useRouteTracker